<div class="row">
    <div class="col-md-6">
        <div class="my-4">
            <h4>Select Provider</h4>
            <div class="row">
                <!-- Display first two items initially -->
                <ng-container *ngIf="!allItemsShown">
                    <div *ngFor="let provider of providersList | slice:0:2" class="col-sm-6 col-md-3 col-lg-3 mb-4">
                        <div class="provider-box me-4" [ngClass]="{'selected-bg': selectedProvider === provider}">
                            <img [src]="provider.image" (click)="selectProvider(provider)" class="img-fluid" />
                        </div>
                    </div>
            
                    <!-- Display 'Others' box -->
                    <div class="col-sm-6 col-md-3 col-lg-3 mb-4">
                        <div class="provider-box me-4" (click)="showAll()">
                            <strong class="text-center">Others</strong>
                        </div>
                    </div>
                </ng-container>
            
                <!-- Display all items if allItemsShown is true -->
                <ng-container *ngIf="allItemsShown">
                    <div *ngFor="let provider of providersList" class="col-sm-6 col-md-3 col-lg-3 mb-4">
                        <div class="provider-box me-4" [ngClass]="{'selected-bg': selectedProvider === provider}">
                            <img [src]="provider.image" (click)="selectProvider(provider)" class="img-fluid" />
                        </div>
                    </div>
                    <!-- Display 'Show Less' box -->
                    <div class="col-sm-6 col-md-3 col-lg-3 mb-4">
                        <div class="provider-box me-4" (click)="showLess()">
                            <strong class="text-center">Show less</strong>
                        </div>
                    </div>
                </ng-container>
            </div>
    
        </div>
        <div class="mb-4">
            <!-- <p-dropdown [options]="models" [(ngModel)]="selectedModel" placeholder="Select a Model" *ngIf="selectedProvider" appendTo="body" class="mb-4"></p-dropdown> -->
            <h4 *ngIf="selectedProvider">Select Model</h4>
            <div class="row" *ngIf="selectedProvider">
                <div *ngFor="let model of models" class="col-sm-6 col-md-6 col-lg-4 mb-4">
                    <div class="model-box me-1" (click)="onModelChange(model)" [ngClass]="{'selected-bg': selectedModelName === model.label}">
                        {{ extractSeries(model.label) }}
                    </div>
                </div>
            </div>
            
        </div>

          <ng-container *ngIf="selectedModel">
            <p><strong>Available</strong>:</p>
            <div class="d-flex flex-wrap mb-4">
                <ng-container *ngFor="let col of getKeys(selectedModel)">
                    
                    <p-chip class="me-2 mb-2" 
                            [styleClass]="'chip-true'"
                            *ngIf="selectedModel[col] === true">
                        {{formatString(col)}}
                        
                    </p-chip>
                </ng-container>
            </div>
            <p><strong>Not Available</strong>:</p>
            <div class="d-flex flex-wrap">
                <ng-container *ngFor="let col of getKeys(selectedModel)">
                    <p-chip class="me-2 mb-2" 
                            [styleClass]="'chip-false'"
                            *ngIf="selectedModel[col] === false">
                            {{formatString(col)}}
                       
                    </p-chip>
                </ng-container>
            </div>
        </ng-container>
    
        <div *ngIf="selectedModel" class="p-4 ps-0 d-flex align-items-center justify-content-start">
            <button type="button" class="p-element p-button-sm p-button p-component" (click)="connect()">
                <i class="ri-add-circle-line align-middle me-1"></i>
                Create Connection Link
            </button>
        </div>
    </div>

    <div class="col-md-6">
        <div class="p-4" *ngIf="connectType === 'apple'">
            <div class="row">
                <div class="col mb-4 d-flex align-items-center justify-content-start">
                    <span class="me-4"><strong>Copy Connection Link</strong></span>
                    <button *ngIf="connectionUrl" pButton pRipple type="button" icon="pi pi-copy" class="p-button-rounded p-button-rounded p-button-outlined me-3" title="Copy COnnection Link" alt="Copy Link"
                                        [cdkCopyToClipboard]="copyConnectionUrl()"
                                        (click)="CopyPopup()"></button>
                </div>
                
                
            </div>
            <h4 class="mb-3">Apple steps</h4>
            <div class="step">
                
                <p>Step-1. Download TerraAvenger App from apple store in Iphone.</p>
                <p>Step-2. Send Link to the User.</p>
                <p>Step-3. From Link connect to apple weearable and open avenger app.</p>
                <p>Step-4. Confirm all the permissions asked by TerraAvenger app.</p>
            </div>
            
        </div>

        <div class="p-4" *ngIf="connectType === 'samsung'">
            <div class="row">
                <div class="col mb-4 d-flex align-items-center justify-content-start">
                    <span class="me-4"><strong>Copy Connection Link</strong></span>
                    <button *ngIf="connectionUrl" pButton pRipple type="button" icon="pi pi-copy" class="p-button-rounded p-button-rounded p-button-outlined me-3" title="Copy COnnection Link" alt="Copy Link"
                                        [cdkCopyToClipboard]="copyConnectionUrl()"
                                        (click)="CopyPopup()"></button>
                </div>
                
                
            </div>
            <h4 class="mb-3">Samsung steps</h4>
            <div class="step">
                
                <p>Step-1. Download Samsung Health an connect your samsung watch.</p>
                <p>Step-2. Download TerraAvenger Apk by this link - https://emoneeds.com/terraAvenger.apk</p>
                <p>Step-3. Send apk link and session link to the User.</p>
                <p>Step-4. Download apk in user's mobile phone and grant all the permisiions asked by app.</p>
                <p>Step-5. From session link click to samsung weearable and it will open terra avenger apk if installed.</p>
                <p>Step-6. Confirm all the permissions asked by TerraAvenger app and click on "Sync Now".</p>
            </div>
            
        </div>

        <div class="p-4" *ngIf="connectType === 'other'">
            <div class="row">
                <div class="col mb-4 d-flex align-items-center justify-content-start">
                    <span class="me-4"><strong>Copy Connection Link</strong></span>
                    <button *ngIf="connectionUrl" pButton pRipple type="button" icon="pi pi-copy" class="p-button-rounded p-button-rounded p-button-outlined me-3" title="Copy COnnection Link" alt="Copy Link"
                                        [cdkCopyToClipboard]="copyConnectionUrl()"
                                        (click)="CopyPopup()"></button>
                </div>
                
                
            </div>
            <h4 class="mb-3">Others Steps</h4>
            <div class="step">
                
                <p>Step-1. Send session Link to user.</p>
                <p>Step-2. After clicking on session url, the user will see different kinds of wearables.</p>
                <p>Step-3. Click on the wearable name and it will redirected to the website of the wearable.</p>
                <p>Step-4. After loging in to that wearable, the connection will be established.</p>
            </div>
            
        </div>
    </div>

    
    
</div>
